import { useEffect } from "react";

/**
 * Sets the document title (and optionally the meta description) for the current page.
 * Restores the previous values when the page unmounts.
 */
export default function useDocumentTitle(title: string, description?: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    let metaEl: HTMLMetaElement | null = null;
    let previousDescription = "";

    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (!metaEl) {
        metaEl = document.createElement("meta");
        metaEl.setAttribute("name", "description");
        document.head.appendChild(metaEl);
      }
      previousDescription = metaEl.getAttribute("content") || "";
      metaEl.setAttribute("content", description);
    }

    return () => {
      document.title = previousTitle;
      if (metaEl && description) {
        metaEl.setAttribute("content", previousDescription);
      }
    };
  }, [title, description]);
}